var bighouse = bighouse || {};

bighouse.pageSidebar = (function () {

    function init() {
        if( $('.js-openSidebar').length === 0 ) return;
        openSidebar();
        closeSidebar();
    }

    const debounceResize = util.debounce(setSidebarHeight, 100);

    function openSidebar(){
        $('.js-openSidebar').on('click', function(e){

            var animateTime = $(window).scrollTop() * 0.25;
            $('body, html').animate({scrollTop: 0}, animateTime);
            initSidebarSizing();

            setTimeout( ()=> { 
                $('.js-stickyNavHeader').addClass('js-stickyNavAnimate');
                $('.Page').addClass('Page--openSidebar');
                $('body, html').addClass('noscroll-mobile');
                resizeThings();
                e.preventDefault();
            }, animateTime);
        });
    }

    function closeSidebar(){
        $('.js-closeSidebar').on('click', function(e){
            closeSidebarFunctions();
            e.preventDefault();
        });
    }

    function closeSidebarFunctions(){
        clearSidebarHeight();
        $('.js-stickyNavHeader').addClass('js-stickyNavAnimate');
        $('.Page').removeClass('Page--openSidebar');
        $('body, html').removeClass('noscroll-mobile');
        resizeThings();
    }


    function initSidebarSizing(){
        setSidebarHeight();
        $(window).on('resize', debounceResize);
    }


    function setSidebarHeight(){
        let paddingTop = parseInt( $('.SearchFilters').css('padding-top').replace('px', ''), 10);
        let paddingBottom = parseInt( $('.SearchFilters').css('padding-bottom').replace('px', ''), 10);
        let filterHeight = $('.SearchFilters-fixed').height();
        let totalHeight = filterHeight + paddingTop + paddingBottom;

        $('.Page-sidebar').css('min-height', totalHeight + 'px');
    }

    function clearSidebarHeight(){
        $(window).off('resize', debounceResize);
        $('.Page-sidebar').css('min-height', '0px');
    }


    function resizeThings(){
        setTimeout( ()=>{
            bighouse.searchCarousel.resizeCarousels(); 
            $('.js-stickyNavHeader').removeClass('js-stickyNavAnimate');
        }, 350);
    }

    return {
        init: init,
        remoteCloseSidebar: closeSidebarFunctions
    };
})();